import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import EntradaDatos from './pages/EntradaDatos';
import Facturacion from './pages/Facturacion';
import Informes from './pages/Informes';
import Estadisticas from './pages/Estadisticas';
import Auditoria from './pages/Auditoria';
import Configuracion from './pages/Configuracion';
import Estabilidades from './pages/Estabilidades';
import Camaras from './pages/Camaras';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Cargando...</div>
      </div>
    );
  }

  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Cargando...</div>
      </div>
    );
  }

  return user ? <Navigate to="/dashboard" /> : children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/entrada-datos"
        element={
          <PrivateRoute>
            <EntradaDatos />
          </PrivateRoute>
        }
      />
      <Route
        path="/estabilidades"
        element={
          <PrivateRoute>
            <Estabilidades />
          </PrivateRoute>
        }
      />
      <Route
        path="/camaras"
        element={
          <PrivateRoute>
            <Camaras />
          </PrivateRoute>
        }
      />
      <Route
        path="/facturacion"
        element={
          <PrivateRoute>
            <Facturacion />
          </PrivateRoute>
        }
      />
      <Route
        path="/informes"
        element={
          <PrivateRoute>
            <Informes />
          </PrivateRoute>
        }
      />
      <Route
        path="/estadisticas"
        element={
          <PrivateRoute>
            <Estadisticas />
          </PrivateRoute>
        }
      />
      <Route
        path="/auditoria"
        element={
          <PrivateRoute>
            <Auditoria />
          </PrivateRoute>
        }
      />
      <Route
        path="/configuracion"
        element={
          <PrivateRoute>
            <Configuracion />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
